import { Link } from '@alfa-bank/site-link';
import { Text } from '@alfa-bank/site-text-v2';
import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import styles from './styles.css';

// TODO: вынести в контент
/**
 * Текст согласия на обработку персональных данных
 */
export const LegalAgreementContent: FC = () => (
    <>
        <Text className={cn(styles.external, styles.headingContent)} tag="h5">
            Согласие на обработку персональных данных, применяемое при направлении заявлений в
            электронном виде в информационно-телекоммуникационной сети «Интернет» на сайте АО
            «АЛЬФА-БАНК» или посредством услуги «Альфа-Мобайл» в целях получения услуг АО
            «АЛЬФА-БАНК» (далее – «Согласие»)
        </Text>
        <Text view="primary-large">
            Я, <strong>(далее – «Заявитель»)</strong>, свободно, своей волей и в своем интересе даю
            конкретное, информированное и сознательное согласие АО «АЛЬФА-БАНК» (г. Москва, ул.
            Каланчевская, д. 27) (далее - «Банк») на обработку информации, относящейся к моим
            персональным данным, в том числе: Ф.И.О.; год, месяц, дата, место рождения; гражданство;
            пол; данные документа, удостоверяющего личность (тип, серия, номер, кем и когда выдан),
            в том числе за пределами Российской Федерации, включая их копии; адрес: места
            жительства, места регистрации, места работы; ИНН; СНИЛС, полис обязательного
            медицинского страхования; полис добровольного медицинского страхования; полис КАСКО;
            информация о состоянии индивидуального лицевого счета застрахованного лица; данные
            водительского удостоверения, включая его копию; сведения о занятости, трудовой
            деятельности (в том числе сведения о трудовом стаже, доходах и расходах), семейное
            положение, имущественное положение, образование, профессия; фотографическое изображение
            и видеоизображение; сведения из кредитной истории, сведения о счетах и картах, о размере
            задолженности перед кредиторами, иная, ранее предоставленная Банку информация; сведения
            о номерах телефонов, абонентом и/или пользователем которых я являюсь; сведения об
            оказанных операторами связи услугах связи (в том числе сведений о местонахождении
            абонентского оборудования при получении услуг связи, сведения о трафике, оказанных
            услугах и их оплате), сведения об идентификаторах абонентского оборудования, иные
            сведения о Заявителе как об абоненте, сведения о результатах их обработки, в том числе
            организация канала коммуникации Банка с использованием телефонных номеров, абонентом
            и/или пользователем которых я являюсь; сведения об адресах электронной почты Заявителя,
            имени пользователя Заявителя в сети Интернет, данные о созданном на сайте Банка или
            мобильном приложении аккаунте (учетной записи); метаданные, данные cookie-файлов,
            cookie-идентификаторы, IP-адреса, сведения о браузере и операционной системе; сведения,
            полученные от третьих лиц, в том числе государственных органов, государственных
            информационных систем, единой системы идентификации и аутентификации (ЕСИА), Пенсионного
            фонда Российской Федерации, в том числе через систему межведомственного электронного
            взаимодействия (СМЭВ), и/или из сети Интернет, и/или из иных общедоступных источников
            персональных данных и любую иную информацию, представленную Банку.
        </Text>
        <Text view="primary-large">
            Обработка персональных данных может осуществляться с использованием средств
            автоматизации или без таковых, а также путем смешанной обработки персональных данных,
            включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление,
            изменение), извлечение, использование, передачу (предоставление, доступ), обезличивание,
            блокирование, удаление, уничтожение персональных данных, в том числе в информационных
            системах Банка, и совершение иных действий, предусмотренных Федеральным законом от
            27.07.2006 № 152-ФЗ «О персональных данных».
        </Text>
        <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
            Целями обработки персональных данных является:
        </Text>
        {/* TODO: перейти на List */}
        <ul>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    заключение с Банком и третьими лицами любых договоров и соглашений;
                </Text>
            </li>
            <li>
                <Text view="primary-large">
                    проверка достоверности указанных Заявителем сведений;
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    получение персональных данных Заявителя из иных разрешенных источников;
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    проверка и оценка платежеспособности и кредитоспособности Заявителя, получение
                    результатов такой оценки, скорингового балла (индивидуального рейтинга) и других
                    показателей благонадежности при рассмотрении Банком возможности заключения с
                    Заявителем любых договоров и соглашений;
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    подбор и предоставление Банком услуг Заявителю;
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    предоставление Заявителю информации о результатах рассмотрения Банком Заявления;
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    создание информационных систем данных, анализ, моделирование, прогнозирование,
                    построение математических (скоринг) моделей, анализ агрегированных и анонимных
                    данных, статистические и исследовательские цели;
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    хранение данных Банком и третьими лицами;
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    продвижение продуктов и услуг Банка и/или третьих лиц, в том числе передача
                    информационных и рекламных сообщений об услугах Банка и/или третьих лиц путем
                    осуществления прямых контактов с помощью средств связи и иным способом.
                </Text>
            </li>
        </ul>
        <Text view="primary-large">
            Заявитель выражает согласие на получение рекламы, предоставление ему информации и
            предложения продуктов Банка и/или третьих лиц путем направления на адреса электронной
            почты, телефонных обращений, SMS-сообщений на телефонные номера, по сети подвижной
            радиотелефонной связи и иным способом.
        </Text>
        <Text view="primary-large">
            В вышеуказанных целях Заявитель дает согласие на обработку перечисленных персональных
            данных Банку и поручение обработки третьим лицам, в том числе перечень которых размещен
            на сайте Банка по ссылке{' '}
            <Link href="https://alfabank.ru/about/list_of_third_parties/" target="_blank">
                alfa.link/partners
            </Link>{' '}
            («Перечень третьих лиц, которые осуществляют обработку персональных данных Клиентов на
            основании заключенных ими с Банком договоров, согласий Клиентов») (далее – «Третьи
            лица»), а также их получение от Третьих лиц.
        </Text>
        <Text view="primary-large">
            Заявитель, являющийся пользователем абонентского номера, указанного в заявлении в
            электронном виде на сайте Банка <strong>(далее – «Пользователь»)</strong>, в целях
            предоставления Банком услуг выражает согласие операторам связи, указанным в Перечне, на
            обработку номеров телефонов, пользователем которых является Пользователь, сведений об
            оказанных операторами услугах связи (в том числе сведений о местонахождении абонентского
            оборудования при получении услуг связи, оплате оказанных услуг связи), сведений об
            идентификаторах абонентского оборудования и передачу указанных сведений или результата
            их обработки Банку, в том числе организацию канала коммуникации Банка с использованием
            телефонных номеров, используемых Пользователем.
        </Text>
        <Text view="primary-large">
            Банк осуществляет обработку персональных данных Заявителя в течение 3 (трех) лет со дня
            подачи настоящего Согласия. В случае, если в течение указанного срока с Заявителем будет
            заключен договор потребительского кредита и/или договор о банковском обслуживании,
            Согласие Заявителя сохраняет силу в течение всего срока действия каждого договора, а
            также в течение 10 (десяти) лет с даты прекращения обязательств сторон по договорам. В
            случае отказа Банка от заключения с Заявителем договоров Банк осуществляет дальнейшее
            хранение персональных данных Заявителя в течение 10 (десяти) лет.
        </Text>
        <Text view="primary-large">
            Согласие может быть отозвано субъектом персональных данных путем обращения в отделение
            Банка с заявлением, оформленным в письменной форме.
        </Text>
    </>
);
